import { Link, useNavigate } from "react-router-dom";
import { useLang } from "../i18n";
import { useSession } from "../lib/session";
import { Icon } from "../components/Icon";
import { PublicFrame } from "./Signup";

// The business's software is closed (migration 044): its trial or subscription has ended, or it has none yet. The
// server refuses every normal request; this screen says so plainly, keeps sign-out, and sends the owner to the
// package screen and the renewal request. Nothing is deleted while it is closed.
export function PackageClosed() {
  const { t } = useLang();
  const { me, signOut } = useSession();
  const nav = useNavigate();
  const p = me?.package;
  const kind = p?.access === "none" ? "none" : p?.kind === "paid" ? "paid" : "trial";
  return (
    <PublicFrame title={t(`pkgClosedTitle_${kind}`)} lede={t(`pkgClosedLede_${kind}`, { d: p?.endsOn ?? "" })}>
      <div className="pkg-closed" data-testid="package-closed" data-access={p?.access}>
        <div className="pkg-closed-row"><Icon name="lock" /><span>{t("pkgClosedData")}</span></div>
        <p>{t(me?.user.owner ? "pkgClosedOwner" : "pkgClosedStaff")}</p>
        <div className="pkg-closed-acts">
          {me?.user.owner && <Link className="btn btn-primary" to="/settings/package" data-testid="closed-open-package"><Icon name="box" />{t("pkgClosedOpen")}</Link>}
          <button className="btn" data-testid="closed-signout" onClick={async () => { await signOut(); nav("/login", { replace: true }); }}><Icon name="logout" />{t("signOut")}</button>
        </div>
        <p className="su-note">{me?.organization ? `${me.organization.nameEn} · ${me.user.name}` : ""}</p>
      </div>
    </PublicFrame>
  );
}
